import { useEffect, useState } from 'react';
import { notification, Collapse } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Link as ScrollLink,
  animateScroll as scroll,
  Element,
} from 'react-scroll';

import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';

import Button from '../../components/Button/Button';
import picture from '../../assets/images/instructor.svg';
import { tutors } from '../../dummyData';
import Place from '../../assets/icons/Place';

const TutorLearnSection = () => {
  const { Panel } = Collapse;
  const ids = useParams();
  const navigate = useNavigate();

  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(false);
  const [schools, setSchools] = useState([]);
  const [activeTab, setActiveTab] = useState('about');
  const [tutor, setTutor] = useState('');

  let school = schools.filter((el) => JSON.stringify(el.id) === ids.schoolId);

  useEffect(() => {
    setLoading(true);
    setTutor(tutors[ids.schoolId - 1]);
    setContent(tutors[ids.schoolId - 1].subjects[ids.subjectId - 1]);
    setLoading(false);
  }, []);

  return (
    <>
      <Helmet>
        <title>PL by Edves | Learn</title>
      </Helmet>
      <DashboardHeader />
      <div className='subject-content-wrapper'>
        <div>
          <div
            className='single-subject__hero'
            style={{
              background: `linear-gradient( 
                rgba(54, 54, 165, 0.7) 100%, 
                rgba(54, 54, 165, 0.7)100%),url(${content?.banner})`,
            }}
            //style={{ backgroundImage: `url(${headerImg})` }}
          >
            <div className='single-subject__hero__breadcrumbs'>
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z'
                  fill='white'
                />
              </svg>
              <p>
                {' '}
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={() => navigate('/dashboard')}
                >
                  Home
                </span>{' '}
                | {content?.title}
              </p>
            </div>
            <h3>{content?.title}</h3>
            <p style={{ marginTop: '18px', color: '#fff', fontSize: '24px' }}>
              Offered by: {school[0]?.name}
            </p>
          </div>

          <div className='learn-tabs'>
            <ScrollLink to='about'>
              <p
                className={
                  activeTab === 'about'
                    ? `learn-tabs__link active-learn-tab`
                    : `learn-tabs__link`
                }
                onClick={() => setActiveTab('about')}
              >
                About This Subject
              </p>
            </ScrollLink>
            <ScrollLink to='features'>
              <p
                className={
                  activeTab === 'features'
                    ? `learn-tabs__link active-learn-tab`
                    : `learn-tabs__link`
                }
                onClick={() => setActiveTab('features')}
              >
                What you'll learn
              </p>
            </ScrollLink>
            <ScrollLink to='instructor'>
              <p
                className={
                  activeTab === 'instructor'
                    ? `learn-tabs__link active-learn-tab`
                    : `learn-tabs__link`
                }
                onClick={() => setActiveTab('instructor')}
              >
                Instructor
              </p>
            </ScrollLink>
            <ScrollLink to='content'>
              <p
                className={
                  activeTab === 'content'
                    ? `learn-tabs__link active-learn-tab`
                    : `learn-tabs__link`
                }
                onClick={() => setActiveTab('content')}
              >
                Subject Content
              </p>
            </ScrollLink>
          </div>
          <div className='learn-flex'>
            <div className='learn-about'>
              <h3>About this subject</h3>
              <p>{content?.description}</p>

              <p className='learn-about__more'>
                Show More
                <svg
                  width='8'
                  height='6'
                  viewBox='0 0 8 6'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M8 1.66656L7.06 0.726563L4 3.7799L0.94 0.726563L0 1.66656L4 5.66656L8 1.66656Z'
                    fill='#FEA82F'
                  />
                </svg>
              </p>
            </div>

            <div className='content-details'>
              <div className='content-details__item'>
                <div className='content-details__item__icon-wrapper'>
                  <svg
                    width='34'
                    height='34'
                    viewBox='0 0 34 34'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M16.983 0.333496C7.78301 0.333496 0.333008 7.80016 0.333008 17.0002C0.333008 26.2002 7.78301 33.6668 16.983 33.6668C26.1997 33.6668 33.6663 26.2002 33.6663 17.0002C33.6663 7.80016 26.1997 0.333496 16.983 0.333496ZM16.9997 30.3335C9.63301 30.3335 3.66634 24.3668 3.66634 17.0002C3.66634 9.6335 9.63301 3.66683 16.9997 3.66683C24.3663 3.66683 30.333 9.6335 30.333 17.0002C30.333 24.3668 24.3663 30.3335 16.9997 30.3335ZM17.833 8.66683H15.333V18.6668L24.083 23.9168L25.333 21.8668L17.833 17.4168V8.66683Z'
                      fill='#5A5955'
                    />
                  </svg>
                </div>
                <div className='content-details__item__text'>
                  <h3>Duration</h3>
                  <p>Estimated {content?.duration} to complete</p>
                </div>
              </div>

              <div className='content-details__item'>
                <div className='content-details__item__icon-wrapper'>
                  <svg
                    width='28'
                    height='28'
                    viewBox='0 0 28 28'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M14.0003 3.99984C15.8337 3.99984 17.3337 5.49984 17.3337 7.33317C17.3337 9.1665 15.8337 10.6665 14.0003 10.6665C12.167 10.6665 10.667 9.1665 10.667 7.33317C10.667 5.49984 12.167 3.99984 14.0003 3.99984ZM14.0003 20.6665C18.5003 20.6665 23.667 22.8165 24.0003 23.9998H4.00033C4.38366 22.7998 9.51699 20.6665 14.0003 20.6665ZM14.0003 0.666504C10.317 0.666504 7.33366 3.64984 7.33366 7.33317C7.33366 11.0165 10.317 13.9998 14.0003 13.9998C17.6837 13.9998 20.667 11.0165 20.667 7.33317C20.667 3.64984 17.6837 0.666504 14.0003 0.666504ZM14.0003 17.3332C9.55032 17.3332 0.666992 19.5665 0.666992 23.9998V27.3332H27.3337V23.9998C27.3337 19.5665 18.4503 17.3332 14.0003 17.3332Z'
                      fill='#5A5955'
                    />
                  </svg>
                </div>
                <div className='content-details__item__text'>
                  <h3>Lesson style</h3>
                  <p>{content?.lesson_style}</p>
                </div>
              </div>

              <div className='content-details__item'>
                <div className='content-details__item__icon-wrapper'>
                  <svg
                    width='40'
                    height='41'
                    viewBox='0 0 40 41'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <g clipPath='url(#clip0_1750_8431)'>
                      <path
                        d='M31.6667 8.53752V32.4423H8.33333V8.53752H31.6667ZM31.6667 5.12256H8.33333C6.5 5.12256 5 6.65929 5 8.53752V32.4423C5 34.3205 6.5 35.8572 8.33333 35.8572H31.6667C33.5 35.8572 35 34.3205 35 32.4423V8.53752C35 6.65929 33.5 5.12256 31.6667 5.12256Z'
                        fill='#5A5955'
                      />
                      <path
                        d='M23.3337 29.027H11.667V25.612H23.3337V29.027ZM28.3337 22.197H11.667V18.7821H28.3337V22.197ZM28.3337 15.3671H11.667V11.9521H28.3337V15.3671Z'
                        fill='#5A5955'
                      />
                    </g>
                    <defs>
                      <clipPath id='clip0_1750_8431'>
                        <rect width='40' height='40.9796' fill='white' />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className='content-details__item__text'>
                  <h3>Lessons</h3>
                  <p>{content?.lessons_count} Lessons</p>
                </div>
              </div>

              <div className='content-details__item'>
                <div className='content-details__item__icon-wrapper'>
                  <svg
                    width='34'
                    height='34'
                    viewBox='0 0 34 34'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M16.983 0.333496C7.78301 0.333496 0.333008 7.80016 0.333008 17.0002C0.333008 26.2002 7.78301 33.6668 16.983 33.6668C26.1997 33.6668 33.6663 26.2002 33.6663 17.0002C33.6663 7.80016 26.1997 0.333496 16.983 0.333496ZM28.533 10.3335H23.6163C23.083 8.25016 22.3163 6.25016 21.3163 4.40016C24.383 5.45016 26.933 7.5835 28.533 10.3335ZM16.9997 3.7335C18.383 5.7335 19.4663 7.95016 20.183 10.3335H13.8163C14.533 7.95016 15.6163 5.7335 16.9997 3.7335ZM4.09967 20.3335C3.83301 19.2668 3.66634 18.1502 3.66634 17.0002C3.66634 15.8502 3.83301 14.7335 4.09967 13.6668H9.73301C9.59967 14.7668 9.49967 15.8668 9.49967 17.0002C9.49967 18.1335 9.59967 19.2335 9.73301 20.3335H4.09967ZM5.46634 23.6668H10.383C10.9163 25.7502 11.683 27.7502 12.683 29.6002C9.61634 28.5502 7.06634 26.4335 5.46634 23.6668ZM10.383 10.3335H5.46634C7.06634 7.56683 9.61634 5.45016 12.683 4.40016C11.683 6.25016 10.9163 8.25016 10.383 10.3335ZM16.9997 30.2668C15.6163 28.2668 14.533 26.0502 13.8163 23.6668H20.183C19.4663 26.0502 18.383 28.2668 16.9997 30.2668ZM20.8997 20.3335H13.0997C12.9497 19.2335 12.833 18.1335 12.833 17.0002C12.833 15.8668 12.9497 14.7502 13.0997 13.6668H20.8997C21.0497 14.7502 21.1663 15.8668 21.1663 17.0002C21.1663 18.1335 21.0497 19.2335 20.8997 20.3335ZM21.3163 29.6002C22.3163 27.7502 23.083 25.7502 23.6163 23.6668H28.533C26.933 26.4168 24.383 28.5502 21.3163 29.6002ZM24.2663 20.3335C24.3997 19.2335 24.4997 18.1335 24.4997 17.0002C24.4997 15.8668 24.3997 14.7668 24.2663 13.6668H29.8997C30.1663 14.7335 30.333 15.8502 30.333 17.0002C30.333 18.1502 30.1663 19.2668 29.8997 20.3335H24.2663Z'
                      fill='#5A5955'
                    />
                  </svg>
                </div>
                <div className='content-details__item__text'>
                  <h3>Language</h3>
                  <p>{content?.language}</p>
                </div>
              </div>

              <Button
                text='Start Learning'
                className='primary-btn'
                width='100%'
                onClick={() =>
                  navigate(`/tutor-start/${ids.subjectId}/${ids.schoolId}`)
                }
              />
            </div>
          </div>
          <Element name='features' smooth='true'>
            <div className='learn-about'>
              <h3>What you'll learn</h3>
              <div className='learn-about__what-you-will-learn'>
                {content?.features?.map((el) => (
                  <div
                    className='learn-about__flex-item'
                    key={Math.random(1000)}
                  >
                    <div className='learn-about__flex-item__circle'>
                      <svg
                        width='16'
                        height='16'
                        viewBox='0 0 16 16'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M6.0001 10.7799L3.2201 7.9999L2.27344 8.9399L6.0001 12.6666L14.0001 4.66656L13.0601 3.72656L6.0001 10.7799Z'
                          fill='#161410'
                        />
                      </svg>
                    </div>
                    <p>{el.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </Element>

          <Element name='instructor' smooth='true'>
            <div className='learn-about instructor'>
              <h3>Instructor</h3>
              <div className='instructor__details'>
                <div className='instructor__details__image'>
                  <img src={tutor.avatar || picture} alt={tutor?.firstName} />
                </div>
                <div className='instructor__details__info'>
                  <h4>{tutor?.firstName}</h4>
                  <div
                    style={{
                      display: 'flex',
                      gap: '10px',
                      alignItems: 'center',
                      marginBottom: '16px',
                    }}
                  >
                    <Place />
                    {school[0]?.state ? (
                      <p style={{ margin: '0' }}>
                        {`${school[0]?.school_state},${
                          school[0]?.country ? school[0]?.country : 'Nigeria'
                        }`}
                      </p>
                    ) : (
                      <p style={{ margin: '0' }}>Lagos,Nigeria</p>
                    )}
                  </div>
                  <p style={{ marginBottom: '8px' }}>{school[0]?.summary}</p>

                  <p
                    className='learn-about__more'
                    onClick={() => navigate(`/schools/${school[0]?.id}`)}
                  >
                    Read More On School Profile
                    <svg
                      width='16'
                      height='16'
                      viewBox='0 0 16 16'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M6.66656 4L5.72656 4.94L8.7799 8L5.72656 11.06L6.66656 12L10.6666 8L6.66656 4Z'
                        fill='#FEA82F'
                      />
                    </svg>
                  </p>
                </div>
              </div>
            </div>
          </Element>

          <Element name='content' smooth='true'>
            <div className='learn-about content'>
              <h3>Subject content</h3>
              {content?.units?.length === 0 ? (
                <div>
                  <p>No lessons available</p>
                </div>
              ) : (
                <div className='content__heading'>
                  <h5>
                    {content?.units?.length} units | {content?.units?.length}{' '}
                    lessons | 30 mins total
                  </h5>
                  <b>
                    Expand all topics{' '}
                    <span>
                      <svg
                        width='6'
                        height='8'
                        viewBox='0 0 6 8'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M1.66852 0L0.728516 0.94L3.78185 4L0.728516 7.06L1.66852 8L5.66852 4L1.66852 0Z'
                          fill='#FEA82F'
                        />
                      </svg>
                    </span>
                  </b>
                </div>
              )}
              <div className='content__topics'>
                <Collapse defaultActiveKey={['1']} expandIconPosition={'right'}>
                  {content?.units?.map((el) => (
                    <Panel
                      header={
                        <>
                          {' '}
                          <span
                            style={{ marginRight: '10px', color: '#5A5955' }}
                          >
                            {el.sn}
                          </span>
                          <span>{el.description}</span>
                        </>
                      }
                      key={el.id}
                      extra={
                        <p className='content__topics__small-text'>
                          {el.duration}
                        </p>
                      }
                    >
                      {el.lessons.map((item) => (
                        <div
                          className='content__topics__sub'
                          onClick={() => {
                            navigate(
                              `/tutor-start/${ids.subjectId}/${ids.schoolId}`
                            );
                            localStorage.setItem(
                              'currentVideo',
                              item?.file_location
                            );
                          }}
                        >
                          <div className='content__topics__sub__left'>
                            <div className='content__topics__sub__left__icon'>
                              {item.type === 'video' ? (
                                <svg
                                  width='14'
                                  height='14'
                                  viewBox='0 0 14 14'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <path
                                    d='M5.66634 9.99992L9.66634 6.99992L5.66634 3.99992V9.99992ZM6.99967 0.333252C3.31967 0.333252 0.333008 3.31992 0.333008 6.99992C0.333008 10.6799 3.31967 13.6666 6.99967 13.6666C10.6797 13.6666 13.6663 10.6799 13.6663 6.99992C13.6663 3.31992 10.6797 0.333252 6.99967 0.333252ZM6.99967 12.3333C4.05967 12.3333 1.66634 9.93992 1.66634 6.99992C1.66634 4.05992 4.05967 1.66659 6.99967 1.66659C9.93967 1.66659 12.333 4.05992 12.333 6.99992C12.333 9.93992 9.93967 12.3333 6.99967 12.3333Z'
                                    fill='#161410'
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width='12'
                                  height='12'
                                  viewBox='0 0 12 12'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <path
                                    d='M7.44667 1.33333L10.6667 4.55333V10.6667H1.33333V1.33333H7.44667ZM7.44667 0H1.33333C0.6 0 0 0.6 0 1.33333V10.6667C0 11.4 0.6 12 1.33333 12H10.6667C11.4 12 12 11.4 12 10.6667V4.55333C12 4.2 11.86 3.86 11.6067 3.61333L8.38667 0.393333C8.14 0.14 7.8 0 7.44667 0ZM2.66667 8H9.33333V9.33333H2.66667V8ZM2.66667 5.33333H9.33333V6.66667H2.66667V5.33333ZM2.66667 2.66667H7.33333V4H2.66667V2.66667Z'
                                    fill='#161410'
                                  />
                                </svg>
                              )}
                            </div>
                            <p>{item.description}</p>
                          </div>
                          <div className='content__topics__sub__right'>
                            <p> {item.duration}</p>
                          </div>
                        </div>
                      ))}
                    </Panel>
                  ))}
                </Collapse>
              </div>
            </div>
          </Element>
          <div className='mobile-learn'>
            <Button
              text='Start Learning'
              className='primary-btn'
              width='100%'
              onClick={() =>
                navigate(`/start/${ids.subjectId}/${ids.schoolId}`)
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TutorLearnSection;
